module.exports = __webpack_public_path__ + "static/logo-563d7f79add4898115c5979e9a8dd5c0.svg";